module.exports = __webpack_public_path__ + "img/1.88a5e064.jpg";